import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CloseButtonComponent } from "../../buttons/close-button/close-button.component";
import { DeleteButtonComponent } from "../../buttons/delete-button/delete-button.component";

@Component({
  selector: 'app-remove-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule, CloseButtonComponent, DeleteButtonComponent],
  templateUrl: './remove-modal.component.html',
  styleUrl: './remove-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RemoveModalComponent {
  readonly label = input<string>('');
  readonly deleteInformation = input<string>('');

  @Output() readonly onCloseClicked = new EventEmitter<void>();
  @Output() readonly onDeleteClicked = new EventEmitter<void>();

  constructor() {}

  onClose(): void {
    this.onCloseClicked.emit();
  }

  onDelete(): void {
    this.onDeleteClicked.emit();
  }
}
